import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GlobalRetailerPersonalDataState,
  RetailerPersonalData,
} from '../common-types/GlobalRetailerPersonalDataState.type';

const initialState: GlobalRetailerPersonalDataState = {
  retailerPersonalData: null,
};

export const globalRetailerPersonalDataSlice = createSlice({
  initialState,
  name: 'GlobalRetailerPersonalData',
  reducers: {
    setRetailerPersonalData (
      state: GlobalRetailerPersonalDataState,
      { payload }: PayloadAction<{ retailerPersonalData: RetailerPersonalData }>
    ): GlobalRetailerPersonalDataState {

      return {
        ...state,
        retailerPersonalData: payload.retailerPersonalData,
      };
    },
  },
});

const { actions, reducer } = globalRetailerPersonalDataSlice;

export const { setRetailerPersonalData } = actions;
export default reducer;
